import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";

import ContactForm from "../../global/forms/contactForm";
import PaymentComponent from "../../global/payment-component";
import CancellationComponent from "./booking-cancellation-component";
import PriceBreakdown from "../../global/booking-price-breakdown-component";
import RequestStayComponent from "./forms/request-stay-component";

import {
  getBooking,
  createBookingRequest,
  chargeBooking,
  cancelBooking,
} from "./actions";
import { navigateTo, pushError } from "../../global/actions";
import { PAGE_ROUTES } from "../../../constants/pageRoutes";
import ShowSuccessToasts from "../../global/successToast";
import ShowErrorToasts from "../../global/errorToast";
import config from "../../../config";
import { PHOTO_PLACEHOLDER } from "../../../constants/images";
import {
  createAffirmCustomer,
  createCustomer,
} from "../../registration/actions";
import { getListingImage } from "../../../constants/util";

export const canAffirmRefresh = () => {
  if (!config.affirmEnabled) return;

  return (
    typeof affirm !== "undefined" &&
    typeof affirm.ui !== "undefined" &&
    typeof affirm.ui.refresh !== "undefined"
  );
};

const mapStateToProps = (state) => ({
  booking: state.Booking,
  global: state.Global,
  user: state.Dashboard.user,
});

function formatAsCurrency(value) {
  return isNaN(value)
    ? null
    : value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

class BookingOverviewComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      paymentModalOpen: false,
      cancellationModalOpen: false,
      isHittingAffirm: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openPaymentModal = this.openPaymentModal.bind(this);
    this.closePaymentModal = this.closePaymentModal.bind(this);
    this.openCancellationModal = this.openCancellationModal.bind(this);
    this.closeCancellationModal = this.closeCancellationModal.bind(this);
    this.submitBookingRequest = this.submitBookingRequest.bind(this);
    this.submitAffirmBookingRequest =
      this.submitAffirmBookingRequest.bind(this);
    this.openAffirm = this.openAffirm.bind(this);
    this.submitPayment = this.submitPayment.bind(this);
    this.submitCancellation = this.submitCancellation.bind(this);
    this.onAffirmSuccess = this.onAffirmSuccess.bind(this);
    this.onAffirmFailure = this.onAffirmFailure.bind(this);
    this.isStreamlineListing = this.isStreamlineListing.bind(this);
    this.getAffirmCheckoutObject = this.getAffirmCheckoutObject.bind(this);
    this.getListingImage = this.getListingImage.bind(this);
  }

  componentWillMount() {
    let { booking, dispatch, match } = this.props;
    if (
      match.path.indexOf("booking-pricing") === -1 &&
      (!booking.selectedBooking ||
        booking.selectedBooking._id !== match.params.id)
    ) {
      dispatch(getBooking(match.params.id));
    }
  }

  componentDidMount() {
    let { history, booking } = this.props;
    //If came here from a listing page, but nothing has been loaded, send back to listing
    if (
      window.location.hash.indexOf("/booking-pricing") >= 0 &&
      !booking.selectedBooking
    ) {
      history.replace(
        window.location.hash.substr(
          1,
          window.location.hash.indexOf("/booking-pricing")
        )
      );
    } else if (booking.selectedBooking) {
      const elements = document.getElementsByClassName(
        "dashboard-booking-overview"
      );
      if (!!elements && elements.length) elements[0].scrollIntoView();
    }

    if (canAffirmRefresh()) affirm.ui.refresh();
  }

  componentDidUpdate(oldProps) {
    let oldBooking = oldProps.booking.selectedBooking;
    let booking = this.props.booking.selectedBooking;
    if (
      this.props.match.path.indexOf("booking-pricing") > -1 &&
      oldBooking &&
      booking &&
      !oldBooking._id &&
      booking._id
    ) {
      this.props.history.replace(`/dashboard/bookings/${booking._id}`);
    }
    if (
      oldBooking &&
      booking &&
      oldBooking.bookingPaymentStatus !== booking.bookingPaymentStatus
    ) {
      this.closePaymentModal();
      this.closeCancellationModal();
    }

    if (canAffirmRefresh()) affirm.ui.refresh();
  }

  isStreamlineListing = () => {
    const { booking } = this.props;
    return !!booking.selectedBooking.listingId.streamId;
  };

  openModal() {
    this.setState({ modalOpen: true });
  }
  closeModal() {
    this.setState({ modalOpen: false });
  }

  openPaymentModal() {
    this.setState({ paymentModalOpen: true });
  }
  closePaymentModal() {
    this.setState({ paymentModalOpen: false });
  }

  openCancellationModal() {
    this.setState({ cancellationModalOpen: true });
  }
  closeCancellationModal() {
    this.setState({ cancellationModalOpen: false });
  }

  submitBookingRequest() {
    let { dispatch, booking } = this.props;
    dispatch(createBookingRequest(booking.selectedBooking));
  }

  submitAffirmBookingRequest(blueSwipeId, checkoutToken) {
    console.log(
      "reached submit affirm booking request",
      blueSwipeId,
      checkoutToken
    );

    let { dispatch, booking } = this.props;
    const affirmBooking = {
      ...booking.selectedBooking,
      checkout_token: checkoutToken,
      blueSwipeId: blueSwipeId,
    };

    dispatch(createBookingRequest(affirmBooking));
  }

  getListingImage = (booking) => {
    if (
      !booking.selectedBooking.listingId.photos ||
      !booking.selectedBooking.listingId.photos.length
    )
      return PHOTO_PLACEHOLDER;

    return getListingImage(booking.selectedBooking.listingId);
  };

  getAffirmCheckoutObject = (user, booking) => {
    const { selectedBooking } = booking;
    const taxAmount =
      selectedBooking.taxPricing.reduce((tax1, tax2) => {
        const a = !!tax1 && !!tax1.price ? tax1.price : 0;
        const b = !!tax2 && !!tax2.price ? tax2.price : 0;
        return a + b;
      }, 0) * 100;

    const total = selectedBooking.total * 100;
    const listing = selectedBooking.listingId;

    const shippingAddress = {
      name: {
        first: user.firstName,
        last: user.lastName,
        full: `${user.firstName} ${user.lastName}`,
      },
      address: {
        country: user.address.country,
        state: user.address.state,
        city: user.address.city,
        zipcode: user.address.zip,
        line1: user.address.address1,
      },
      phone_number: user.phoneNumber ? user.phoneNumber.toString() : "",
      email: user.email,
    };

    return {
      merchant: {
        public_api_key: config.affirmKey,
        user_confirmation_url: location.protocol + "//" + location.host,
        user_cancel_url: location.protocol + "//" + location.host,
        name: "CollegeWeekends",
        use_vcn: true,
      },
      shipping: shippingAddress,
      items: [
        {
          sku: listing._id,
          display_name: listing.listingName,
          unit_price: listing.pricing.baseFee,
          qty: 1,
          item_url: `/listing/${listing._id}`,
          item_image_url: this.getListingImage(booking),
        },
      ],
      currency: "USD",
      shipping_amount: 0,
      taxAmount: Math.round(taxAmount),
      total: Math.round(total),
      metadata: {
        mode: "modal",
      },
    };
  };

  openAffirm() {
    const { user, dispatch, booking } = this.props;

    if (this.state.isHittingAffirm || !booking || !booking.selectedBooking)
      return;

    if (!user) {
      dispatch(pushError("Please login to continue!"));
      setTimeout(() => {
        dispatch(navigateTo(PAGE_ROUTES.LOGIN));
      }, 1000);
      return;
    }

    let checkoutObject = this.getAffirmCheckoutObject(user, booking);
    console.log("affirm checkout", checkoutObject);

    affirm.checkout(checkoutObject);
    affirm.checkout.open({
      onFail: this.onAffirmFailure,
      onSuccess: this.onAffirmSuccess,
    });
  }

  onAffirmSuccess = (card_response) => {
    const { dispatch, user } = this.props;
    console.log("AFFIRM_SUCCESS", card_response);

    const [firstName, lastName] = card_response.cardholder_name.split(" ");
    const yearFirstTwo = new Date().getFullYear().toString().substring(0, 2);

    dispatch(
      createAffirmCustomer({
        bill_firstName: firstName,
        bill_lastName: lastName,
        bill_phoneNumber: user.phoneNumber,
        bill_email: user.email,
        bill_address1: card_response.billing_address.line1,
        bill_address2: card_response.billing_address.line2,
        bill_zip: card_response.billing_address.zipcode,
        bill_city: card_response.billing_address.city,
        bill_state: card_response.billing_address.state,
        card_number: parseInt(card_response.number),
        card_expMonth: card_response.expiration.substring(0, 2),
        card_expYear: `${yearFirstTwo}${card_response.expiration.substring(2)}`,
        card_cvv: card_response.cvv,
      })
    ).then((response) => {
      this.submitAffirmBookingRequest(
        response.customerId,
        card_response.checkout_token
      );
    });
  };

  onAffirmFailure = (error_response) => {
    console.error("AFFIRM_FAILURE", error_response);
  };

  submitPayment() {
    let { dispatch, booking } = this.props;
    if (booking.selectedBooking._id) {
      dispatch(chargeBooking(booking.selectedBooking._id));
    } else {
      this.submitBookingRequest();
    }
  }

  submitCancellation() {
    let { dispatch, booking } = this.props;
    dispatch(cancelBooking(booking.selectedBooking._id));
  }

  renderModal(booking, isOwner) {
    if (!this.state.modalOpen) return null;

    let userToMessage = isOwner
      ? booking.selectedBooking.userId
      : booking.selectedBooking.listingId.userId;
    return (
      <ContactForm
        onClose={this.closeModal}
        onSubmit={this.closeModal}
        values={{
          contactUser: userToMessage,
          bookingId: booking.selectedBooking._id,
        }}
      />
    );
  }

  renderPaymentModal(user, total) {
    if (!this.state.paymentModalOpen) return null;
    return (
      <PaymentComponent
        onSubmit={this.submitPayment}
        onClose={this.closePaymentModal}
        user={user}
        total={total}
      />
    );
  }

  renderCancellationModal() {
    if (!this.state.cancellationModalOpen) return null;

    return (
      <CancellationComponent
        onSubmit={this.submitCancellation}
        onClose={this.closeCancellationModal}
      />
    );
  }

  renderStatus(booking) {
    let status = "";
    if (booking.bookingRequestStatus === "Rejected") {
      status = <div className="pl-3">{booking.bookingRequestStatus}</div>;
    } else if (booking.bookingRequestStatus === "Pending") {
      status = (
        <div className="pl-3 red">{`${booking.bookingRequestStatus} Approval`}</div>
      );
    } else if (
      booking.bookingPaymentStatus === "Pending" ||
      booking.bookingPaymentStatus === "Error"
    ) {
      status = <div className="pl-3 red">{`Pending Payment`}</div>;
    } else if (booking.bookingPaymentStatus === "Cancelled") {
      status = <div className="pl-3 red">{booking.bookingPaymentStatus}</div>;
    } else if (booking.bookingPaymentStatus) {
      status = <div className="pl-3">{booking.bookingPaymentStatus}</div>;
    }

    return status ? (
      <div className="col-12">
        <div className="font-weight-bold">Status</div>
        {status}
      </div>
    ) : (
      <div />
    );
  }

  renderRenterButtons(booking, history) {
    let primaryButton = <div />;
    let affirmButton = null;
    let affirmText = null;

    if (!booking._id && booking.listingId.bookingSetting === "Request") {
      return (
        <RequestStayComponent
          primaryAction={this.submitBookingRequest}
          secondaryAction={() => history.goBack()}
        />
      );
    } else if (
      !booking._id ||
      (booking._id &&
        booking.bookingRequestStatus === "Accepted" &&
        (booking.bookingPaymentStatus === "Pending" ||
          booking.bookingPaymentStatus === "Error"))
    ) {
      primaryButton = (
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.openPaymentModal}
        >
          Checkout
        </button>
      );

      if (config.affirmEnabled) {
        affirmButton = (
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.openAffirm}
          >
            Pay with Affirm
          </button>
        );
        affirmText = (
          <p
            className="affirm-as-low-as affirm-text-link"
            data-page-type="product"
            data-amount={booking.total * 100}
          ></p>
        );
      }
    } else if (
      (booking._id && booking.bookingRequestStatus === "Pending") ||
      booking.bookingRequestStatus === "Error"
    ) {
      primaryButton = (
        <button type="button" className="btn btn-primary" disabled={true}>
          Pending Approval
        </button>
      );
    } else if (
      booking._id &&
      booking.bookingPaymentStatus === "Paid" &&
      moment(booking.startDate).isSameOrAfter(moment(), "d")
    ) {
      primaryButton = (
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.openCancellationModal}
        >
          Cancel Booking
        </button>
      );
    }
    return (
      <div className="button-row row">
        <div className="col">
          <label onClick={() => history.goBack()}>Back</label>
        </div>
        <div className="col text-right right-button-affirm">
          {affirmButton}
          {primaryButton}
          {!!affirmButton && !!affirmText && (
            <div className="affirm-text">{affirmText}</div>
          )}
        </div>
        {/* for responsive */}
        <div className="responsive-affirm-text">
          <div className="affirm-text">{affirmText}</div>
        </div>
      </div>
    );
  }

  renderOwnerButtons(booking, history) {
    return (
      <div className="button-row row">
        <div className="col">
          <label onClick={() => history.goBack()}>Back</label>
        </div>

        <div className="col text-right"></div>
      </div>
    );
  }

  render() {
    let { user, booking, global, history } = this.props;
    if (!booking.selectedBooking) return <div>Loading...</div>;
    let startDate = moment(booking.selectedBooking.startDate);
    let endDate = moment(booking.selectedBooking.endDate);
    let numDays = Math.ceil(endDate.diff(startDate, "d", true));
    let isOwner =
      booking.selectedBooking.userId &&
      booking.selectedBooking.userId._id !== global.userId;

    const listingImage = this.getListingImage(booking);

    return (
      <div className="container dashboard-booking-overview">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="row">
          <div className="col">
            <h2>Booking Overview</h2>
          </div>
        </div>
        <div className="row">
          {booking.selectedBooking.listingId.photos.length > 0 && (
            <div className="col-md-6 p-3 image-container">
              <div style={{ backgroundImage: `url(${listingImage})` }} />
            </div>
          )}
          <div className="col-md-6 p-3">
            <div className="row">
              <div className="col-12 d-flex flex-wrap align-items-baseline">
                <h5 className="mr-2">
                  {booking.selectedBooking.listingId.listingName}
                </h5>
                {booking.selectedBooking._id && (
                  <span>
                    (
                    <Link
                      to={`/listing/${booking.selectedBooking.listingId._id}`}
                    >
                      View Listing
                    </Link>
                    )
                  </span>
                )}
              </div>
              {booking.selectedBooking._id &&
                this.renderStatus(booking.selectedBooking)}
              {booking.selectedBooking.userId &&
                booking.selectedBooking.userId.firstName && (
                  <div className="col-12">
                    <div className="font-weight-bold">Renter</div>
                    <div className="pl-3">
                      {`${booking.selectedBooking.userId.firstName} ${booking.selectedBooking.userId.lastName}`}
                      {isOwner && (
                        <span>
                          (
                          <Link
                            to={`/profile/${booking.selectedBooking.userId._id}`}
                          >
                            View Profile
                          </Link>
                          )
                        </span>
                      )}
                    </div>
                  </div>
                )}
              <div className="col-12">
                <div className="font-weight-bold">Travel Dates</div>
                <div className="pl-3">
                  {startDate.format("M/D")} - {endDate.format("M/D")} ({numDays}{" "}
                  night{numDays === 1 ? "" : "s"})
                </div>
              </div>
              <div className="col-12">
                <div className="font-weight-bold">Number of Guests</div>
                <div className="pl-3">
                  {booking.selectedBooking.numGuests} guests
                </div>
              </div>
              {booking.selectedBooking._id && (
                <div className="col-12 mt-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={this.openModal}
                  >
                    {isOwner ? "Contact Renter" : "Contact Owner"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <PriceBreakdown
          booking={booking.selectedBooking}
          isOwner={isOwner}
          isStreamlineListing={this.isStreamlineListing()}
        />
        {!booking.selectedBooking._id || !isOwner
          ? this.renderRenterButtons(booking.selectedBooking, history)
          : this.renderOwnerButtons(booking.selectedBooking, history)}
        {this.renderModal(booking, isOwner)}
        {this.renderPaymentModal(user, booking.selectedBooking.total)}
        {this.renderCancellationModal()}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(BookingOverviewComponent));
